export const SET_SUPPLIER = 'SET_SUPPLIER'
export const RESET_SUPPLIER = 'RESET_SUPPLIER'
